import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import LikeButton from '@/shared-components/buttons/components/LikeButton';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import TextHandler from '@/shared-components/text/components/TextHandler';
import Utils from '@/utils';
import { hasRenderableThought } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

import './styles/ArtworkInlineTitle.css';
import './styles/ProfileThoughtCard.css';

export default function ProfileThoughtCard({ data, onLikeAction }) {
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  if (!hasRenderableThought(data)) {
    return null;
  }
  const thoughtLikesCount = Number(data.thought_likes_count) || 0;
  const isFollowing = resolveFollowState({
    cacheHandler,
    userId: data.thought_creator?._id,
    imFollowing: data.thought_creator?.im_following,
  });

  // const renderDate = () => {
  //   if (showDate) {
  //     return (
  //       <Text className="profile-thought-card__small-text" extraSmall paragraph>
  //         {Utils.elapsedTime(new Date(data.createdAt).getTime())}
  //       </Text>
  //     );
  //   }
  //   return null;
  // };

  return (
    <>
      <div
        className={`profile-thought-card__container ${isFollowing ? 'following' : ''}`}
        onClick={() =>
          navigate(`/artwork/${data.thought_artwork.slug}?thought=${data._id}`, {
            state: {
              from: true,
              artworkViewSource: {
                type: 'community',
                label: '',
              },
            },
          })
        }
      >
        <div className="profile-thought-card__thought-content">
          <UserProfileImage
            image={data.thought_creator.user_image?.image_id}
            typeOfProfile={data.thought_creator.user_type}
            className="profile-thought-card__user-image"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/user/${data.thought_creator.user_username}`);
            }}
          />

          <div className="profile-thought-card__text-content">
            <div className="text-custom__component profile-thought-card__small-text margin">
              <span
                className="username"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/user/${data.thought_creator.user_username}`);
                }}
              >
                {data.thought_creator.user_username}
              </span>

              <span className="profile-thought-card__small-text-separator">
                on
              </span>
              <span className="artwork-inline-title">
                {data.thought_artwork.artwork_about.artwork_title}
              </span>
            </div>

            <TextHandler
              moreControlClick={() => {}}
              className="profile-thought-card__thought-text-container"
              maxCharactersWhenCollapsed={400}
              controlsClassName="profile-thought-card__thought-text-controls"
              text={data.thought_message} />

            {/* {renderDate()} */}
          </div>
        </div>

        <div className="profile-thought-card__thought-like-image-section">
          <div className="profile-thought-card__thought-like-section">
            <LikeButton
              itemId={data._id}
              typeOfItem="THOUGHT"
              isLiked={data.is_liked}
              className="profile-thought-card__thought-like-icon"
              onLikeAction={onLikeAction}
            />

            {thoughtLikesCount > 0 && (
              <Text className="profile-thought-card__small-text profile-thought-card__likes-count" paragraph>
                {Utils.numberParserMillionThousand(thoughtLikesCount)}
              </Text>
            )}
          </div>

          <ArtworkImage
            image={data.thought_artwork.artwork_media.artwork_main_picture.image_id}
            imageClassName="profile-thought-card__thought-image"
            imageTemplateClassName="profile-thought-card__thought-image"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/artwork/${data.thought_artwork.slug}`, {
                state: {
                  from: true,
                  artworkViewSource: {
                    type: 'community',
                    label: '',
                  },
                }
              });
            }}
            forceSmaller={300}
          />
        </div>
      </div>
    </>
  );
}
